import { useTranslation } from 'react-i18next';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

// Shown in proxy (forward-auth) mode when the upstream-authenticated user isn't provisioned in this app.
// NOT a login prompt — the proxy already authenticated them; an admin must grant access. The button hands
// off to the proxy/Entra sign-out so they can retry as a different account.
export function AccessDenied() {
  const { t } = useTranslation('common');
  const { logout } = useAuth();

  return (
    <div className="min-h-dvh flex items-center justify-center bg-slate-50 px-6">
      <div className="max-w-md w-full text-center space-y-5">
        <div className="mx-auto w-14 h-14 rounded-full bg-red-100 flex items-center justify-center">
          <ShieldAlert className="w-7 h-7 text-red-600" />
        </div>
        <h1 className="text-xl font-bold text-slate-800">{t('accessDenied.title')}</h1>
        <p className="text-sm text-slate-500 leading-relaxed">{t('accessDenied.message')}</p>
        <button
          type="button"
          onClick={() => logout()}
          className="inline-flex items-center justify-center px-4 py-2.5 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-brand-rose to-brand-orange hover:-translate-y-px hover:shadow-lg transition-all duration-300"
        >
          {t('accessDenied.switchAccount')}
        </button>
      </div>
    </div>
  );
}
